import React from "react"
import Hero from "../assets/hero.jpg"
import {MdOutlineKeyboardArrowRight} from 'react-icons/md'
import {Link} from "react-scroll"


const Home = () => {
  return (
    <div name="home" className="h-screen w-full bg-gradient-to-b
    from-white via-white to-cyan-900 ">

        <div className="max-w-screen-lg mx-auto flex flex-col
        items-center justify-center h-full px-4 md:flex-row">
            <div className="flex flex-col justify-center h-full">
                <h2 className="text-2xl sm:text-7xl font-bold py-5">
                    Hi, I am Bikash Baishnab
                </h2>
                <p className="text-gray-700 py-4 max-w-md font-semibold">
                    I have expericence in development and designing software.
                    Presently, I am working on web application and cloud
                    technologies.
                </p>
                <div>
                    <Link to="Blogs" smooth duration ={500} className="group text-white w-fit px-6 py-3 my-2 
                    flex items-center rounded-md bg-gradient-to-r
                    from-cyan-500 to-blue-500 cursor-pointer">
                        Blogs
                        <span className="group-hover:rotate-90 duration-300">
                            <MdOutlineKeyboardArrowRight size={25} className="ml-1"/>               
                        </span>
                        
                    </Link>
                </div>
            </div>
            <div>
                <img src={Hero} alt="my profile" 
                className="rounded-2xl mx-auto w-2/3 md:w-full"/>
            </div>
        </div>
    </div>
  );
};

export default Home